import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import InfoBadge from "@/components/base/InfoBadge";
import { formatDate, getCategoryName } from "@/utils/content";

export default function Hero() {
  const featured = articles.find((a) => a.featured) ?? articles[0];

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-12 lg:gap-10 lg:py-16">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-live-line" aria-hidden="true"></i>
            中立梳理 · 持续更新
          </div>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl lg:text-[2.75rem]">
            灵灵事件信息梳理站
            <span className="mt-2 block text-xl font-semibold text-foreground-700 md:text-2xl">
              把碎片信息，拼成一条能看懂的脉络
            </span>
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            围绕「灵灵黑料」争议，本站只整理公开可查的信息：本人回应要点、工作室声明逐句解读、传闻辟谣分析，以及按时间排列的后续进展。不站队、不爆料，只标注每一条信息的可信等级。
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/article/timeline-full"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-timeline-view" aria-hidden="true"></i>
              查看完整时间线
            </Link>
            <Link
              to="/about"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              了解信息分级标准
            </Link>
          </div>

          <dl className="mt-8 grid grid-cols-2 gap-4 border-t border-background-200 pt-6 sm:grid-cols-4">
            <div>
              <dt className="text-xs text-foreground-500">可核验节点</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-primary-600">6</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">已梳理文章</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-primary-600">{articles.length}</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">已标注传闻</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-600">4</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">最近更新</dt>
              <dd className="mt-1 font-heading text-lg font-bold text-foreground-900">09-08</dd>
            </div>
          </dl>
        </div>

        <div className="lg:col-span-5">
          <Link
            to={`/article/${featured.id}`}
            className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50"
          >
            <div className="relative h-52 w-full overflow-hidden sm:h-64">
              <img
                src={featured.cover}
                alt={`${featured.title} - 灵灵事件信息梳理头图`}
                title={`${featured.title}｜灵灵事件梳理`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <InfoBadge level={featured.infoLevel} />
                <h2 className="mt-2 font-heading text-lg font-bold leading-snug text-background-50 md:text-xl">
                  {featured.title}
                </h2>
              </div>
            </div>
            <div className="flex items-center justify-between gap-3 px-4 py-3 text-xs text-foreground-500">
              <span className="flex items-center gap-2">
                <span className="text-primary-600">{getCategoryName(featured.category)}</span>
                <span aria-hidden="true">·</span>
                <span>{formatDate(featured.date)}</span>
              </span>
              <span className="flex items-center gap-1 text-primary-600">
                阅读
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}